import {offerListCardGalleryModalSlice} from "@/components/offer_list_card/state/offer_list_card_gallery_modal_slice";
import {applicationSlice} from "@/features/applications/state/application_slice";
import {authModalSlice} from "@/features/auth/state/auth_modal_slice";
import {authSlice} from "@/features/auth/state/auth_slice";
import {bigDataApi} from "@/features/big_data/api/big_data_api";
import {favoritesListSlice} from "@/features/favorites/list/state/favorites_list_slice";
import {homeMatchSlice} from "@/features/home_match/state/home_match_slice";
import {investmentGalleryModalSlice} from "@/features/investment_list/state/investment_gallery_modal_slice";
import {investmentInquiriesSlice} from "@/features/investment_list/state/investment_inquiries_slice";
import {investmentLeadModalSlice} from "@/features/investment_list/state/investment_lead_modal_slice";
import {kmApi} from "@/features/km_app/api/km_api";
import {rpApi} from "@/features/km_app/api/rp_api";
import {variablesSlice} from "@/features/km_app/state/variables_slice";
import {openStreetMapApi} from "@/features/map/api/open_street_map_api";
import {mapUiSlice} from "@/features/map/state/map_ui_slice";
import {notificationSlice} from "@/features/notifications/state/notifications_slice";
import {propertyGalleryModalSlice} from "@/features/properties/state/property_gallery_modal_slice";
import {propertySlice} from "@/features/properties/state/property_slice";
import {userApi} from "@/features/user/api/user_api";
import {userPhoneVerificationSlice} from "@/features/user/state/user_phone_verification_slice";

export const reducer = {
    [applicationSlice.name]: applicationSlice.reducer,
    [authModalSlice.name]: authModalSlice.reducer,
    [authSlice.name]: authSlice.reducer,
    [favoritesListSlice.name]: favoritesListSlice.reducer,
    [homeMatchSlice.name]: homeMatchSlice.reducer,
    [investmentGalleryModalSlice.name]: investmentGalleryModalSlice.reducer,
    [investmentInquiriesSlice.name]: investmentInquiriesSlice.reducer,
    [investmentLeadModalSlice.name]: investmentLeadModalSlice.reducer,
    [mapUiSlice.name]: mapUiSlice.reducer,
    [notificationSlice.name]: notificationSlice.reducer,
    [offerListCardGalleryModalSlice.name]: offerListCardGalleryModalSlice.reducer,
    [propertyGalleryModalSlice.name]: propertyGalleryModalSlice.reducer,
    [propertySlice.name]: propertySlice.reducer,
    [variablesSlice.name]: variablesSlice.reducer,
    [userPhoneVerificationSlice.name]: userPhoneVerificationSlice.reducer,

    // API
    [bigDataApi.reducerPath]: bigDataApi.reducer,
    [kmApi.reducerPath]: kmApi.reducer,
    [openStreetMapApi.reducerPath]: openStreetMapApi.reducer,
    [rpApi.reducerPath]: rpApi.reducer,
    [userApi.reducerPath]: userApi.reducer
};
import {offerListCardGalleryModalSlice} from "@/components/offer_list_card/state/offer_list_card_gallery_modal_slice";
import {applicationSlice} from "@/features/applications/state/application_slice";
import {authModalSlice} from "@/features/auth/state/auth_modal_slice";
import {authSlice} from "@/features/auth/state/auth_slice";
import {bigDataApi} from "@/features/big_data/api/big_data_api";
import {favoritesListSlice} from "@/features/favorites/list/state/favorites_list_slice";
import {homeMatchSlice} from "@/features/home_match/state/home_match_slice";
import {investmentGalleryModalSlice} from "@/features/investment_list/state/investment_gallery_modal_slice";
import {investmentInquiriesSlice} from "@/features/investment_list/state/investment_inquiries_slice";
import {investmentLeadModalSlice} from "@/features/investment_list/state/investment_lead_modal_slice";
import {kmApi} from "@/features/km_app/api/km_api";
import {rpApi} from "@/features/km_app/api/rp_api";
import {variablesSlice} from "@/features/km_app/state/variables_slice";
import {openStreetMapApi} from "@/features/map/api/open_street_map_api";
import {mapUiSlice} from "@/features/map/state/map_ui_slice";
import {notificationSlice} from "@/features/notifications/state/notifications_slice";
import {propertyGalleryModalSlice} from "@/features/properties/state/property_gallery_modal_slice";
import {propertySlice} from "@/features/properties/state/property_slice";
import {userApi} from "@/features/user/api/user_api";
import {userPhoneVerificationSlice} from "@/features/user/state/user_phone_verification_slice";

export const reducer = {
    [applicationSlice.name]: applicationSlice.reducer,
    [authModalSlice.name]: authModalSlice.reducer,
    [authSlice.name]: authSlice.reducer,
    [favoritesListSlice.name]: favoritesListSlice.reducer,
    [homeMatchSlice.name]: homeMatchSlice.reducer,
    [investmentGalleryModalSlice.name]: investmentGalleryModalSlice.reducer,
    [investmentInquiriesSlice.name]: investmentInquiriesSlice.reducer,
    [investmentLeadModalSlice.name]: investmentLeadModalSlice.reducer,
    [mapUiSlice.name]: mapUiSlice.reducer,
    [notificationSlice.name]: notificationSlice.reducer,
    [offerListCardGalleryModalSlice.name]: offerListCardGalleryModalSlice.reducer,
    [propertyGalleryModalSlice.name]: propertyGalleryModalSlice.reducer,
    [propertySlice.name]: propertySlice.reducer,
    [variablesSlice.name]: variablesSlice.reducer,
    [userPhoneVerificationSlice.name]: userPhoneVerificationSlice.reducer,

    // API
    [bigDataApi.reducerPath]: bigDataApi.reducer,
    [kmApi.reducerPath]: kmApi.reducer,
    [openStreetMapApi.reducerPath]: openStreetMapApi.reducer,
    [rpApi.reducerPath]: rpApi.reducer,
    [userApi.reducerPath]: userApi.reducer
};
